import React from 'react';
import { cn } from '../../utils/cn';
import { useProjectPanelStore, useFilteredAssets, useChildFolders } from '../../store/projectPanelStore';
import { AssetRow } from './AssetRow';
import { FolderRowItem } from './FolderRowItem';

export const AssetList: React.FC = () => {
  const { selectedAssetId, selectedAssetIds, selectAsset, filter, setSortBy, toggleSortDirection } = useProjectPanelStore();
  const assets = useFilteredAssets();
  const childFolders = useChildFolders();

  const handleHeaderClick = (column: 'name' | 'type' | 'size' | 'modified') => {
    if (filter.sortBy === column) toggleSortDirection();
    else setSortBy(column);
  };

  const SortIndicator = ({ column }: { column: string }) => {
    if (filter.sortBy !== column) return null;
    return <span className="ml-1 text-blue-400">{filter.sortDirection === 'asc' ? '↑' : '↓'}</span>;
  };

  const hasContent = childFolders.length > 0 || assets.length > 0;

  if (!hasContent) {
    return (
      <div className="flex-1 flex items-center justify-center text-zinc-500 text-sm">
        <div className="text-center">
          <div className="text-4xl mb-2">📂</div>
          <div>Empty folder</div>
          <div className="text-xs mt-1">Drag files here or use Import</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <div className="flex items-center px-2 py-1.5 bg-zinc-800 border-b border-zinc-700 text-xs text-zinc-500 font-medium select-none">
        <div className="flex-1 min-w-[200px] cursor-pointer hover:text-zinc-300" onClick={() => handleHeaderClick('name')}>Name <SortIndicator column="name" /></div>
        <div className="w-24 cursor-pointer hover:text-zinc-300" onClick={() => handleHeaderClick('type')}>Type <SortIndicator column="type" /></div>
        <div className="w-20 text-right cursor-pointer hover:text-zinc-300" onClick={() => handleHeaderClick('size')}>Size <SortIndicator column="size" /></div>
        <div className="w-24 text-right cursor-pointer hover:text-zinc-300" onClick={() => handleHeaderClick('modified')}>Modified <SortIndicator column="modified" /></div>
      </div>
      <div className="flex-1 overflow-y-auto">
        {childFolders.map((folder) => (
          <FolderRowItem key={folder.id} folder={folder} />
        ))}
        {assets.map((asset) => (
          <AssetRow key={asset.id} asset={asset} isSelected={selectedAssetId === asset.id || selectedAssetIds.includes(asset.id)} onSelect={selectAsset} />
        ))}
      </div>
    </div>
  );
};
